import { type ImgHTMLAttributes, useState } from "react";
import { FALLBACK_FAVICON } from "@/utils/reference";

/**
 * 웹 출처 파비콘. 외부 파비콘 서비스를 못 부르면(내부망, 방화벽) 기본 아이콘으로 바꾼다.
 * 실패한 주소를 기억해 두어, 다른 출처로 바뀌면 다시 시도한다.
 */
const FaviconImage = ({ src, onError, ...props }: ImgHTMLAttributes<HTMLImageElement>) => {
  const [failedSrc, setFailedSrc] = useState<string>();
  return (
    <img
      {...props}
      src={src !== undefined && src === failedSrc ? FALLBACK_FAVICON : src}
      onError={(e) => {
        setFailedSrc(src);
        onError?.(e);
      }}
    />
  );
};

export default FaviconImage;
